<oes-nav-header></oes-nav-header>

<oes-organization-list
  *ngIf="developerOrganizations"
  [organizations]="developerOrganizations"
  [exportName]="'Developer List'"
  [profileType]="'developer'">
</oes-organization-list>
